import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/home'
import TrainProgram from '../views/trainMange/trainProgram'
import TrainPlain from '../views/trainMange/trainPlain'
import CoursePreview from '../views/trainMange/coursePreview'
import StuTrainProgram from '../views/trainUse/stuTrainProgram'
import StuCourse from '../views/trainUse/stuCourse'


Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'trainProgram',
    component: TrainProgram,
  },
  {
    path: '/trainProgram',
    name: 'trainProgram',
    component: TrainProgram,
  },
  {
    path: '/trainPlain',
    name: 'trainPlain',
    component: TrainPlain,
  },
  {
    path: '/coursePreview',
    name: 'coursePreview',
    component: CoursePreview,
  },

  {
    path: '/stuTrainProgram',
    name: 'stuTrainProgram',
    component: StuTrainProgram,
  },
  {
    path: '/stuCourse',
    name: 'stuCourse',
    component: StuCourse,
  },
]

const router = new VueRouter({
  routes
})

export default router
